import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiUser, FiBell, FiShield, FiDatabase } from 'react-icons/fi';

const Settings = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <h2 className="text-2xl font-bold">System Preferences</h2>

      <div className="glass-panel rounded-3xl overflow-hidden">
        <div className="p-6 border-b border-[#2a2d4f] flex items-center">
          <div className="w-16 h-16 rounded-full bg-[#eaff00] flex items-center justify-center text-[#0b0c1b] text-2xl font-bold mr-4">
            S
          </div>
          <div>
            <h3 className="text-lg font-bold">Scholar Alpha</h3>
            <p className="text-sm text-slate-400">scholar@university.edu</p>
          </div>
          <button className="ml-auto bg-[#15172b] border border-[#2a2d4f] px-4 py-2 rounded-lg text-sm hover:border-[#eaff00]/50 transition-colors">
            Edit Profile
          </button>
        </div>

        <div className="p-2">
          {[
            { icon: FiBell, label: 'Notification Protocols', desc: 'Manage push and email alerts' },
            { icon: FiDatabase, label: 'Data Sync', desc: 'Manage offline storage and cloud backup' },
            { icon: FiShield, label: 'Privacy & Security', desc: 'Biometrics and session management' },
          ].map((item, idx) => (
            <div key={idx} className="flex items-center p-4 hover:bg-[#2a2d4f]/30 rounded-xl cursor-pointer transition-colors">
              <div className="w-10 h-10 rounded-full bg-[#15172b] flex items-center justify-center mr-4 border border-[#2a2d4f]">
                <SafeIcon icon={item.icon} className="text-slate-300" />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-slate-200">{item.label}</h4>
                <p className="text-xs text-slate-500">{item.desc}</p>
              </div>
              <div className="w-10 h-6 bg-[#eaff00] rounded-full relative opacity-50 cursor-not-allowed">
                <div className="absolute right-1 top-1 w-4 h-4 bg-[#0b0c1b] rounded-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center pt-12 pb-8 opacity-60">
        <p className="text-sm tracking-widest uppercase text-slate-500 mb-2">System Architecture</p>
        <p className="text-xs text-slate-400">Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer">LingLinkAI.cn</a></p>
        <p className="text-[10px] text-slate-600 mt-2">StudyHalo Core v.2.4.1 // Secure Node</p>
      </div>
    </div>
  );
};

export default Settings;